import { useEffect, type RefObject } from 'react';

export function useNearScrollTop(
  scrollRef: RefObject<HTMLElement | null>,
  onNearTop: () => void,
  options: { thresholdPx?: number; disabled?: boolean } = {},
) {
  const { thresholdPx = 120, disabled = false } = options;

  useEffect(() => {
    const element = scrollRef.current;
    if (!element || disabled) {
      return;
    }

    let ticking = false;

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(() => {
        ticking = false;

        if (element.scrollTop <= thresholdPx) {
          onNearTop();
        }
      });
    };

    element.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [disabled, onNearTop, scrollRef, thresholdPx]);
}
